export default {
  '一键复制微信号\'': '[一键复制微信号\']',
  '上传中': 'Uploading',
  '上传执行照片邀请码\'': '[Upload 执行照片邀Please 码\']',
  '上传提示\'': 'Upload Notice\'',
  '上传照片': '[Upload 照片]',
  '上传照片\'': '[Upload 照片\']',
  '上传照片可精准预测最佳病虫防治时间\'': '[Upload 照片可精准预测最佳病虫防治时间\']',
  '下发专家\'': '[下发专家\']',
  '下发农事"': '[下发Farm Work"]',
  '专家': '[专家]',
  '专属数字农场，种好卖好': 'Your digital farm — grow better, sell better',
  '为了将农事方案与您的品种匹配，请您录入品种信息\'': '[为了将Farm Work方案与您的Variety匹配，Please 您录入Variety信息\']',
  '为了更好校准您的农事执行时间\'': '[为了更好校准您的Farm Work执行时间\']',
  '之前\'': '[之前\']',
  '二级\'': '[二级\']',
  '二维码弹窗 --': '[二维码弹窗 --]',
  '互动主题：': '[Interaction主题：]',
  '亩\'': '[亩\']',
  '人工\'': '[人工\']',
  '代森锰锌\'': '[代森锰锌\']',
  '以上表型进入该阶段\'': '[以上表型进入该阶段\']',
  '伴随间歇性小雨或雾天。\'': '[伴随间歇性小雨或雾天。\']',
  '作业农事\'': '[作业Farm Work\']',
  '作业周期\'': '[作业周期\']',
  '作业面积\'': '[作业面积\']',
  '作物块（每个农场一块） --': '[Crop块（每个Farm一块） --]',
  '作物档案 --': 'Crop Archives --',
  '作物档案：外层可滚动，滚动位置单独缓存以便路由': '[Crop Archives：外层可滚动，滚动位置单独缓存以便路由]',
  '作物长势\'': '[Crop长势\']',
  '作物长势报告': 'Crop Growth Report',
  '使用功效\'': '[使用功效\']',
  '使用设备\'': '[使用设备\']',
  '保存图片\'': 'Save图片\'',
  '修改地址\'': '[修改地址\']',
  '全区"': '[全区"]',
  '全部': 'All',
  '全部日期\'': 'All日期\'',
  '六成': '60%',
  '六成\'': '[六成\']',
  '关注农事': '[关注Farm Work]',
  '其他\'': '[其他\']',
  '内容卡片 --': '[内容卡片 --]',
  '内置标题模板 --': '[内置标题模板 --]',
  '农事凭证\'': '[Farm Work凭证\']',
  '农事名称\'': '[Farm Work名称\']',
  '农事宗旨\'': '[Farm Work宗旨\']',
  '农事建议': 'Farming advice',
  '农事建议\'': 'Farming Advice\'',
  '农事执行图片"': '[Farm Work执行图片"]',
  '农事方案\'': '[Farm Work方案\']',
  '农事时间\'': '[Farm Work时间\']',
  '农事目的\'': '[Farm Work目的\']',
  '农事组信息 --': '[Farm Work组信息 --]',
  '农事编号\'': '[Farm Work编号\']',
  '农事编号：': '[Farm Work编号：]',
  '农事规划\'"': 'Farm Planning\'"',
  '农事详情\'': '农事Details\'',
  '农场亩数 --': '[Farm亩数 --]',
  '农场亩数\'': '[Farm亩数\']',
  '农场位置 --': '[Farm位置 --]',
  '农场位置\'': '[Farm位置\']',
  '农场位置：\'': '[Farm位置：\']',
  '农场信息维护': 'Farm profile',
  '农场列表': 'Farm list',
  '农场列表 --': 'Farm List --',
  '农场列表引导 --': 'Farm List引导 --',
  '农场名称\'': '[Farm名称\']',
  '农场名称：\'': '[Farm名称：\']',
  '农场品种 --': 'FarmVariety --',
  '农场品种\'': 'FarmVariety\'',
  '农场品类 --': '[Farm品类 --]',
  '农场品类\'': '[Farm品类\']',
  '农场基本信息\'': '[Farm基本信息\']',
  '农场筛选 --': 'FarmFilter --',
  '农场详情\'': '农场Details\'',
  '农场面积\'': '[Farm面积\']',
  '农场面积：\'': '[Farm面积：\']',
  '农情互动\'': '[农情 Interaction\']',
  '农事档案\'': 'Crop Archives\'',
  '农情照片"': '[农情照片"]',
  '农情照片\'': '[农情照片\']',
  '农情研判：\'': '[农情研判：\']',
  '农情详情\'': '农情Details\'',
  '分区管理\'': '[分区管理\']',
  '创建 --': '[创建 --]',
  '创建农场"': '[创建Farm"]',
  '创建农场\'"': '[创建Farm\'"]',
  '删除地块\'': 'Delete地块\'',
  '加入下方指导群可解锁': '[加入下方指导群可解锁]',
  '加入冼老师种植群\'': '[加入冼老师种植群\']',
  '加载中': 'Loading',
  '勾画区域\'': '[勾画区域\']',
  '勾画区域\'"': '[勾画区域\'"]',
  '勾选地块\'"': '[勾选Plot\'"]',
  '勾选地块获得农场面积\'': '[勾选Plot获得Farm面积\']',
  '区域勾选\'': '[区域勾选\']',
  '单亩用量\'': '[单亩用量\']',
  '历史风险\'': '[历史 Risk\']',
  '历史风险报告': 'Historical Risk Reports',
  '历史风险报告\'': 'Historical Risk Reports\'',
  '历史高发风险\'': '[历史高发 Risk\']',
  '去勾选\'': '[去勾选\']',
  '发起需求"': '[发起需求"]',
  '取消': 'Cancel',
  '取消\'': 'Cancel\'',
  '取消修改\'': 'Cancel修改\'',
  '取消关注\'': 'Cancel关注\'',
  '取消勾选\'': 'Cancel勾选\'',
  '可选': '[可选]',
  '右箭头 --': '[右箭头 --]',
  '名称\'': '[名称\']',
  '周一': 'Mon',
  '周三': 'Wed',
  '周二': 'Tue',
  '周五': 'Fri',
  '周六': 'Sat',
  '周四': 'Thu',
  '周日': 'Sun',
  '咨询专家\'': '[咨询专家\']',
  '品种选择 --': 'VarietySelect --',
  '四大种植报告生成成功 --': '[四大种植 Report生成 Success --]',
  '图片"': '[图片"]',
  '图片列表 --': '[图片列表 --]',
  '图片区域 --': '[图片区域 --]',
  '图片消息 --': '[图片消息 --]',
  '土壤性质\'': '[土壤性质\']',
  '土壤改良\'': '[土壤改良\']',
  '土壤改良报告': '[土壤改良 Report]',
  '地图 --': '[地图 --]',
  '地形': '[地形]',
  '基本信息\'': '[基本信息\']',
  '增加品种': '[增加Variety]',
  '壤土\'': '[壤土\']',
  '处于{stage}': 'in {stage}',
  '处于为 分蘖初期\'': '[处于为 分蘖初期\']',
  '处方卡片 --': '[处方卡片 --]',
  '处方详情 --': '处方Details --',
  '处方详情\'': '处方Details\'',
  '复制方案"': '[复制方案"]',
  '复核\'"': '[复核\'"]',
  '复核成效\'': '[复核成效\']',
  '复核照片\'': '[复核照片\']',
  '天\'': '[天\']',
  '天了': '[天了]',
  '天后\'': '[天后\']',
  '天气 --': 'Weather --',
  '天气遮罩 --': '[Weather遮罩 --]',
  '头部区域 --': '[头部区域 --]',
  '如果不确定是否发生，直接上传照片即可\'': '如果不OK是否发生，直接上传照片即可\'',
  '完善以下信息，生成智能种植方案\'': '[完善以下信息，生成智能种植方案\']',
  '完善作物品种以及物候信息，精准匹配种植方案，实现精细化管理': '[完善CropVariety以及物候信息，精准匹配种植方案，实现精细化管理]',
  '对方消息 --': '[对方消息 --]',
  '对策建议：': 'Recommendations: ',
  '对话样式消息 --': '[对话样式消息 --]',
  '小麦\'': '[小麦\']',
  '展开\'': 'Expand \'',
  '展开更多': 'Expand',
  '展开详细操作指南\'': '[Expand 详细操作指南\']',
  '山德生\'': '[山德生\']',
  '巡园建议：\'': '[Patrol 建议：\']',
  '巡园提醒：': '[Patrol 提醒：]',
  '巡园要点：\'': '[Patrol 要点：\']',
  '巡园重点': 'Patrol priorities',
  '左箭头 --': '[左箭头 --]',
  '已全部生成\'': '已All生成\'',
  '已关注"': '[已关注"]',
  '已发起需求"': '[已发起需求"]',
  '已完成\'': '已Done\'',
  '已激活\'': '[已激活\']',
  '已认证成功': '[已认证 Success]',
  '带锁 --': '[带锁 --]',
  '干旱预警': 'Drought alert',
  '广州市从化区江埔街九里步\'': '[广州市从化区江埔街九里步\']',
  '底部操作按钮 --': '[底部操作按钮 --]',
  '建模航线提示弹窗（复用': '[建模航线 Notice弹窗（复用]',
  '建议勾选\'': '[建议勾选\']',
  '开始采集': '[开始采集]',
  '异常信息区域 --': '[异常信息区域 --]',
  '当前': 'Current',
  '当前农场': 'Current farm',
  '当前日期：2025': '[Current 日期：2025]',
  '当前日期：{date}': 'Current date: {date}',
  '当前膨果期对病虫害高度敏感，易受害。经过飞鸟智慧大脑计算病虫风险:病虫胁迫指数处于中等水平，存在一定的病虫害发生风险，局部区域可能出现病害流行或虫害爆发，需加强监测预警，及时巡园': 'During fruit expansion, crops are highly sensitive to pests and diseases. Feiniao AI assessment: moderate pest stress index. Local outbreaks are possible — strengthen monitoring and patrols.',
  '当前荔枝处于果实膨大期，近期存在强降水和强对流天气频发的情况，且当前识别到阴雨气象风险较高3级，累计阴雨天数达12天、日均湿度约91%。连续阴雨导致光照不足，月累计日照时数较常年偏少17%，叶片光合效率下降，碳水化合物合成减少"': '当前荔枝处于果实膨大期，近期存在强降水和强对流天气频发的情况，且当前识别到阴雨Weather Risks较高3级，累计阴雨天数达12天、日均湿度约91%。连续阴雨导致光照不足，月累计日照时数较常年偏少17%，叶片光合效率下降，碳水化合物合成减少"',
  '当前荔枝处于果期，预测田间病虫害气象风险2级，近期湿度达88%、日均气温达30': '当前荔枝处于果期，预测田间病虫害Weather Risks2级，近期湿度达88%、日均气温达30',
  '当季作物：\'': '[当季Crop：\']',
  '待记录\'': '[待记录\']',
  '微信\'': '[微信\']',
  '您的农场已绑定成功': 'Your farm has been linked successfully',
  '您的四大种植报告\'': '[您的四大种植 Report\']',
  '成果报告\'': '[成果 Report\']',
  '我\'': '[我\']',
  '我已执行 --': '[我已执行 --]',
  '我已执行\'': '[我已执行\']',
  '托管农事 会触发农情互动，并且为您推送农事，取消关注 则不会为您推送任何与该农事相关的内容"': '托管农事 会触发农情互动，并且为您推送农事，Cancel关注 则不会为您推送任何与该农事相关的内容"',
  '托管农事"': '[托管Farm Work"]',
  '托管农事\'': '[托管Farm Work\']',
  '托管农户：首页、农事档案、农事记录 --': '托管农户：首页、Crop Archives、农事记录 --',
  '执行区域': '[执行区域]',
  '执行区域 --': '[执行区域 --]',
  '执行区域\'': '[执行区域\']',
  '执行区域地图弹窗 --': '[执行区域地图弹窗 --]',
  '执行操作\'': '[执行操作\']',
  '执行方式\'': '[执行方式\']',
  '执行日期\'': '[执行日期\']',
  '执行时间\'': '[执行时间\']',
  '执行时间已经过去': '[执行时间已经过去]',
  '执行时间已过去 7 天\'': '[执行时间已过去 7 天\']',
  '执行时间：': '[执行时间：]',
  '执行最佳': '[执行最佳]',
  '执行档案 --': '[执行 Archives --]',
  '执行档案\'': '[执行 Archives\']',
  '执行照片\'': '[执行照片\']',
  '执行码\'': '[执行码\']',
  '执行组织': '[执行组织]',
  '执行轨迹 --': '[执行轨迹 --]',
  '执行轨迹\'': '[执行轨迹\']',
  '执行，执行时间需巡园校准': '[执行，执行时间需Patrol 校准]',
  '拖动手柄 --': '[拖动手柄 --]',
  '按钮区域 --': '[按钮区域 --]',
  '按钮样式 --': '[按钮样式 --]',
  '推荐时间\'': '[推荐时间\']',
  '推荐时间：': '[推荐时间：]',
  '提交成功\'': 'Submit成功\'',
  '提交方案\'': 'Submit方案\'',
  '提交有误\'': 'Submit有误\'',
  '提示：关注农事': '[Notice：关注Farm Work]',
  '搜索位置\'': 'Search位置\'',
  '搜索农场': 'Search farms',
  '搜索品类\'': 'Search品类\'',
  '搜索框 --': 'Search框 --',
  '操作提示：拖动圆点，即可调整地块边界\'': '[操作 Notice：拖动圆点，即可调整Plot边界\']',
  '收起': 'Collapse',
  '收起\'': 'Collapse\'',
  '文本消息 --': '[文本消息 --]',
  '新增农事\'': 'Add Farm Work\'',
  '新增农场': 'Add farm',
  '新增农场 --': 'Add Farm --',
  '新增品种': 'Add Variety',
  '新增品种\'': 'Add Variety\'',
  '新增用户"': '[Add 用户"]',
  '新增用户\'': '[Add 用户\']',
  '新建管理分区\'': '[新建管理分区\']',
  '方式\'': '[方式\']',
  '方案设置"': '[方案设置"]',
  '施用方式\'': '[施用方式\']',
  '无人机咨询：飞鸟购买 --': '[无人机咨询：飞鸟购买 --]',
  '无处方\'': '[无处方\']',
  '时间和位置\'': '[时间和位置\']',
  '星期三\'': '[星期三\']',
  '是否有10%的荔枝发现蒂蛀虫为害特征？': 'Do 10% of lychee trees show litchi stem borer damage?',
  '是否有60%的荔枝进入果实转色期？': 'Have 60% of lychee trees entered fruit color-change stage?',
  '是是否有10%的荔枝出现生理落果或裂果症状': 'Do 10% of lychee trees show physiological drop or fruit cracking?',
  '晴天': 'Sunny',
  '智能分析\'': '[智能分析\']',
  '暂无内容\'': '[No 内容\']',
  '暂无地址': 'No address',
  '暂无处方': '[No 处方]',
  '暂无处方\'': '[No 处方\']',
  '暂无巡园提醒"': '[No Patrol 提醒"]',
  '暂无提示"': 'No Notice"',
  '暂无数据"': 'No Data"',
  '暂无数据\'': 'No Data\'',
  '暂无记录\'': '[No 记录\']',
  '暂未检测到工人执行\'': '[暂未检测到工人执行\']',
  '暂未检测到拍照\'': '[暂未检测到拍照\']',
  '有效期：2025': '[有效期：2025]',
  '有机质\'': '[有机质\']',
  '服务农场': '[服务Farm]',
  '服务详情模式的内容 --': '服务Details模式的内容 --',
  '未上传状态内容 --': '[未Upload 状态内容 --]',
  '未完善\'': '[未完善\']',
  '未执行\'': '[未执行\']',
  '未来7-15天气象风险': '7–15 day weather risks',
  '未来七天天气': '7-day forecast',
  '未激活\'': '[未激活\']',
  '未监测您果园有配套的无人机，您可咨询飞鸟购买\'': '[未监测您Orchard有配套的无人机，您可咨询飞鸟购买\']',
  '果实是否开始由扁圆变圆、横径明显增大？\'': '[果实是否开始由扁圆变圆、横径明显增大？\']',
  '果实由扁圆形开始横向增宽，果皮青绿色有光泽，果实横径明显增大，果肩逐渐饱满。 巡园要点：重点观察树冠外围中上部结果枝，检查果实形状变化和横径大小，统计进入快速膨大的果实比例。拍照记录果实膨大状态，上传存档。"': '[果实由扁圆形开始横向增宽，果皮青绿色有光泽，果实横径明显增大，果肩逐渐饱满。 Patrol 要点：重点观察树冠外围中上部结果枝，检查果实形状变化和横径大小，统计进入快速膨大的果实比例。拍照记录果实膨大状态，Upload 存档。"]',
  '果径是否显著小于正常果，且果皮失去光泽、呈现暗哑状态？\'': '[果径是否显著小于正常果，且果皮失去光泽、呈现暗哑状态？\']',
  '柑橘\'': '[柑橘\']',
  '查看互动\'': 'View互动\'',
  '查看全部农场列表，并可创建农场': 'View all farms and create new ones',
  '查看农事\'': 'View农事\'',
  '查看区域\'': 'View区域\'',
  '查看更多\'': 'View更多\'',
  '查看详情\'': '查看Details\'',
  '标题 --': '[标题 --]',
  '标题区域 --': '[标题区域 --]',
  '校准物候期 --': 'Calibrate Phenology --',
  '校准物候期）\'': 'Calibrate Phenology）\'',
  '根外追肥': 'Foliar feeding',
  '桂味': '[桂味]',
  '桂味\'': '[桂味\']',
  '桂味-上市时间：06': '[桂味-上市时间：06]',
  '梢期杀虫\'': '[梢期杀虫\']',
  '橙色状态头部 --': '[橙色状态头部 --]',
  '此二维码为': '[此二维码为]',
  '每一段农事 --': '[每一段Farm Work --]',
  '每日农情打卡，享一对一专家指导\'': '[每日农情打卡，享一对一专家指导\']',
  '气象风险': 'Weather risks',
  '气象风险\'"': 'Weather Risks\'"',
  '水印相机': '[水印相机]',
  '水稻\'': 'Rice\'',
  '没有更多了\'': '没有More了\'',
  '注意事项\'': '[注意事项\']',
  '添加"': '[添加"]',
  '潜在危害：田间湿度过高极易诱发霜疫霉病、炭疽病等真菌病害，病菌侵染幼果后导致腐烂、脱落。影响幼果正常发育和果皮着色，可能造成裂果、烂果。\'': '[潜在危害：田间湿度过高极易诱发霜疫霉病、炭疽病等真菌病害，病菌侵染幼果后导致腐烂、脱落。影响幼果正常发育和果皮着色，可能造成裂果、烂果。\']',
  '点击展开更多': 'Show more',
  '点击收起': 'Collapse',
  '点击新建管理分区\'': '[Tap 新建管理分区\']',
  '点击查看\'': '点击View\'',
  '点击编辑\'': '点击Edit\'',
  '点击解锁': 'Unlock',
  '点击解锁\'': 'Unlock\'',
  '点击解锁一键溯源增产': 'Tap to unlock traceability & yield boost',
  '点击解锁一键溯源增产\'': 'Tap to Unlock Traceability & Yield Boost\'',
  '点击选择作物"': 'Tap Select Crop"',
  '点样式 --': '[点样式 --]',
  '物候期设置': '[Phenological Stage设置]',
  '物候风险': '[物候 Risk]',
  '生成成果报告\'': '[生成成果 Report\']',
  '生育期背景：同一': '[Reproductive Stage背景：同一]',
  '由于系统审核，您照片拍摄位置与农场相差超 3 公里，请在农场现场使用水印相机重新拍摄上传，谢谢配合\'': '[由于系统审核，您照片拍摄位置与Farm相差超 3 公里，Please 在Farm现场使用水印相机重新拍摄Upload ，谢谢配合\']',
  '由于系统审核，某些照片拍摄位置与农场相差超 3 公里，请在农场现场使用水印相机重新拍摄上传，谢谢配合': '[由于系统审核，某些照片拍摄位置与Farm相差超 3 公里，Please 在Farm现场使用水印相机重新拍摄Upload ，谢谢配合]',
  '界定标准：\'': '[界定标准：\']',
  '界定标准：{ratio} 以上表型进入该阶段': 'Criterion: over {ratio} of plants show this stage',
  '病害': '[病害]',
  '病害"': '[病害"]',
  '病虫互动': 'Pest check',
  '病虫害列表 --': '[病虫害列表 --]',
  '病虫害态势监控\'': '[病虫害态势监控\']',
  '病虫害态势监控\'"': '[病虫害态势监控\'"]',
  '病虫风险': 'Pest & disease risk',
  '的果园情况，请查看': '的果园情况，请View',
  '的物候期\'': '[的Phenological Stage\']',
  '的生育期\'': '[的Reproductive Stage\']',
  '确认': 'Confirm',
  '确认\'': 'Confirm\'',
  '确认上传\'': 'Confirm上传\'',
  '确认修改"': 'Confirm修改"',
  '确认农场区域\'': 'Confirm农场区域\'',
  '确认区域\'': 'Confirm区域\'',
  '确认执行时间 --': 'Confirm执行时间 --',
  '示例图片\'': '[示例图片\']',
  '示例照片\'': '[示例照片\']',
  '示例照片轮播组件 --': '[示例照片轮播组件 --]',
  '示范农场': 'Demo Farm',
  '种植作物\'': '[种植Crop\']',
  '种植区域': '[种植区域]',
  '种植建议\'': '[种植建议\']',
  '种植建议报告': '[种植建议 Report]',
  '种植档案管理': 'Planting Records',
  '种植类别\'': '[种植类别\']',
  '科普知识：\'': '[科普知识：\']',
  '稍后执行"': '[稍后执行"]',
  '立即分享\'': '[立即分享\']',
  '立即分享给好友\'': '[立即分享给好友\']',
  '立即创建"': '[立即创建"]',
  '立即获取': '[立即获取]',
  '第一步：农场信息填写 --': '[第一步：Farm信息填写 --]',
  '类型\'': '[类型\']',
  '类型切换 --': '[类型切换 --]',
  '精准施治，智慧护航\'': '[精准施治，智慧护航\']',
  '组件：天气 --': '[组件：Weather --]',
  '组合照片（用于生成合成图片） --': '[组合照片（用于生成合成图片） --]',
  '经过飞鸟智慧大脑计气象风险:阴雨寡照胁迫指数处于中等水平，存在一定的植株缺素风险，局部区域可能会出现长势异常现象，需加强监测预警，及时巡园': 'Feiniao AI weather assessment: moderate rain/low-light stress. Nutrient deficiency may occur in some areas with abnormal growth — strengthen monitoring and patrols.',
  '绿色标签 --': '[绿色标签 --]',
  '编辑信息\'': 'Edit信息\'',
  '编辑农场"': 'Edit农场"',
  '编辑农场\'': 'Edit农场\'',
  '群 --': '[群 --]',
  '聊天消息区域 --': '[聊天消息区域 --]',
  '背景描述：': 'Background: ',
  '膨果期': 'Fruit expansion stage',
  '自定义内容插槽 --': '[自定义内容插槽 --]',
  '自定义标题插槽 --': '[自定义标题插槽 --]',
  '航线已生成） --': '[航线已生成） --]',
  '节点': '[节点]',
  '荔枝': 'Lychee',
  '荔枝\'': 'Lychee\'',
  '荔枝膨果期遇持续阴雨寡照，需及时排水防渍，重点根外喷施磷酸二氢钾并配合补充钙硼肥，以快速恢复树势、促进膨果壮果。': 'During prolonged rain and low light in fruit expansion, improve drainage. Apply potassium dihydrogen phosphate foliar spray with calcium and boron to restore vigor and promote fruit sizing.',
  '荔枝长势报告': 'Lychee Growth Report',
  '药物处方': '[药物处方]',
  '药物处方\'': '[药物处方\']',
  '药物处方：': '[药物处方：]',
  '药物处方：\'': '[药物处方：\']',
  '药肥名称\'': '[药肥名称\']',
  '药肥处方\'': '[药肥处方\']',
  '药肥类型\'': '[药肥类型\']',
  '药肥配比\'': '[药肥配比\']',
  '蒂蛀虫、荔枝蝽蟓、炭疽病、霜疫霉病\'': '[蒂蛀虫、Lychee蝽蟓、炭疽病、霜疫霉病\']',
  '虫害': '[虫害]',
  '虫害防治': 'Pest control',
  '表单区域 --': '[表单区域 --]',
  '表型特征：\'': '[表型特征：\']',
  '触发农事"': '[触发Farm Work"]',
  '触发时间为今天\'': '[触发时间为今天\']',
  '触发时间已过\'': '[触发时间已过\']',
  '触发条件\'': '[触发条件\']',
  '设为默认农场': 'Set as default',
  '识别结果：该病为该病为该病为该病为病为该病为病为该病为\'': '[识别结果：该病为该病为该病为该病为病为该病为病为该病为\']',
  '该农场\'': '[该Farm\']',
  '该页面正在升级，敬请期待': '[该页面正在升级，敬Please 期待]',
  '语音消息 --': '[语音消息 --]',
  '请上传农事执行现场照片及所用药肥凭证照片\'': '[Please Upload Farm Work执行现场照片及所用药肥凭证照片\']',
  '请使用 水印相机': '[Please 使用 水印相机]',
  '请确认 具体勾画类别\'': '请Confirm 具体勾画类别\'',
  '请确认勾画类型\'': '请Confirm勾画类型\'',
  '请设置互动问题': '[Please 设置 Interaction问题]',
  '请设置互动问题\'': '[Please 设置 Interaction问题\']',
  '请输入\'': 'Please Enter\'',
  '请输入农场位置\'': 'Please Enter农场位置\'',
  '请输入农场的真实面积\' "': 'Please Enter农场的真实面积\' "',
  '请输入农资机构名称\'': 'Please Enter农资机构名称\'',
  '请输入您的农场名称\'': 'Please Enter您的农场名称\'',
  '请输入病虫害名称\'': 'Please Enter病虫害名称\'',
  '请选择\'': 'Please Select\'',
  '请选择下次提醒时间': 'Please Select下次提醒时间',
  '请选择互动时间': 'Please Select互动时间',
  '请选择互动阶段': 'Please Select互动阶段',
  '请选择实际执行时间': 'Please Select实际执行时间',
  '请选择异常类型\'': 'Please Select异常类型\'',
  '请选择当前\'': 'Please Select当前\'',
  '请选择当前{species}的物候期': 'Select phenological stage for {species}',
  '请选择当前{species}的生育期': 'Select reproductive stage for {species}',
  '请选择您的土壤类型\'': 'Please Select您的土壤类型\'',
  '请选择日期\'': 'Please Select日期\'',
  '请选择物候期': 'Please select phenological stage',
  '请选择物候期\'': 'Please Select物候期\'',
  '请选择生育期': 'Please select reproductive stage',
  '请选择类型\'': 'Please Select类型\'',
  '质地\'': '[质地\']',
  '起始时间\'': '[起始时间\']',
  '距离执行时间还差': '[距离执行时间还差]',
  '跳过\'': '[跳过\']',
  '轨道：横线': '[轨道：横线]',
  '转发\'': '[转发\']',
  '转发处方\'': '[转发处方\']',
  '转发执行二维码\'': '[转发执行二维码\']',
  '转发操作指南\'': '[转发操作指南\']',
  '过往种植：\'': '[过往种植：\']',
  '返回后恢复 --': 'Back后恢复 --',
  '这是': '[这是]',
  '进程互动': 'Progress check',
  '进行拍摄照片照片需要显示 时间和位置 水印"': '[进行拍摄照片照片需要显示 时间和位置 水印"]',
  '连续多列合并为一格，标题与描述跨列居中 --': '[连续多列合并为一格，标题与描述跨列居中 --]',
  '选择作物\'': 'Select Crop\'',
  '选择品种\'': 'Select Variety\'',
  '选择品类': 'Category',
  '选择品类\'': 'Select Category\'',
  '选择地区': 'Region',
  '通过叶面喷施针对性杀虫剂，快速压低蒂蛀虫种群数量，保护果实免受蛀害。': 'Targeted foliar insecticides can quickly reduce litchi stem borer populations and protect fruit from damage.',
  '邀请关注 --': 'Invite to Follow --',
  '邀请关注\'': 'Invite to Follow\'',
  '邀请您进行农情互动\'': '[邀Please 您进行农情 Interaction\']',
  '邀请拍照\'': '[邀Please 拍照\']',
  '配比\'': '[配比\']',
  '重点巡视低洼地、排水不畅的粘重土壤果园，以及树冠中下部及内膛果实。观察果实膨大进度，对比不同方位果穗大小差异；观察叶片萎蔫程度和黄化部位。拔根检查根系状态': '[重点巡视低洼地、排水不畅的粘重土壤Orchard，以及树冠中下部及内膛果实。观察果实膨大进度，对比不同方位果穗大小差异；观察叶片萎蔫程度和黄化部位。拔根检查根系状态]',
  '重置区域\'': '[重置区域\']',
  '长势互动': 'Growth check',
  '长势异常态势跟踪\'': '[长势异常态势跟踪\']',
  '长势异常态势跟踪\'"': '[长势异常态势跟踪\'"]',
  '长势报告"': 'Growth Report"',
  '长按二维码保存或转发': '长按二维码Save或转发',
  '长按可添加客服，咨询相关问题\'': '[长按可添加客服，咨询相关问题\']',
  '长按图片保存或转发': '长按图片Save或转发',
  '阴雨寡照风险': 'Rain & low-light risk',
  '阶段文案': '[阶段文案]',
  '韦帮稳"': '[韦帮稳"]',
  '顶部状态 --': '[顶部状态 --]',
  '顶部说明 --': '[顶部说明 --]',
  '预警等级：黄色预警（中等风险），建议在未来48小时内启动预防措施。\'': '[预警等级：黄色预警（中等 Risk），建议在Future 48小时内启动预防措施。\']',
  '预计': '[预计]',
  '预计报价：': '[预计报价：]',
  '预计未来7天平均相对湿度': '[预计Future 7天平均相对湿度]',
  '预计激活时间': '[预计激活时间]',
  '风险描述风险描述风险描述风险描述风险': '[Risk描述 Risk描述 Risk描述 Risk描述 Risk]',
  '飞鸟\'': '[飞鸟\']',
  '飞鸟种植助手\'"': '[飞鸟种植助手\'"]',
  '高发区域：\'': '[高发区域：\']',
  '高湿环境利于蒂蛀虫等害虫繁殖，成虫活动增加，增加后期虫果率。\'': '[高湿环境利于蒂蛀虫等害虫繁殖，成虫活动增加，增加后期虫果率。\']',
  '高湿风险：\'': '[高湿 Risk：\']',
  '默认内容 --': '[默认内容 --]',
};